import CasinoLandingCard from "./CasinoLandingCard";

export interface AudienceCard {
  id: string;
  heading: string;
  subheading: string;
  checklistItems: string[];
  ctaText: string;
}

export interface AudienceCardsConfig {
  cards: AudienceCard[];
}

interface AudienceCardsProps {
  config?: AudienceCardsConfig;
}

export default function AudienceCards({ config }: AudienceCardsProps) {
  if (!config || !config.cards || config.cards.length === 0) {
    return null;
  }

  const pageStyle = {
    background: "transparent",
    minHeight: "auto",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    gap: "60px",
  };

  return (
    <div style={pageStyle}>
      {config.cards.map((card) => (
        <CasinoLandingCard
          key={card.id}
          heading={card.heading}
          subheading={card.subheading}
          checklistItems={card.checklistItems}
          ctaText={card.ctaText}
          onCtaClick={() => {
            console.log(`${card.heading} CTA clicked`);
          }}
        />
      ))}
      {/* Responsive styles */}
      <style>{`
        @media (max-width: 1024px) {
          div[style*="gap: 60px"] {
            gap: 40px !important;
            padding: 40px 20px !important;
          }
        }

        @media (max-width: 640px) {
          div[style*="gap: 60px"] {
            gap: 32px !important;
            padding: 32px 16px !important;
          }
        }
      `}</style>
    </div>
  );
}

